import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class ModalFilterListeSalaries extends Vue {
	public NomNaissanceVisible = false;
	public QualificationVisible = false;
	public DateEntreeVisible = false;
	public DateDebutContratVisible = false;
	public DateDepartVisible = false;
	public DateFinContratVisible = false;
	public TypeContratVisible = false;
	public RegimeVisible = false;
	public BulletinParMailVisible = false;
	public NatureContratVisible = false;
	public RemunerationVisible = false;
	public CongesVisible = false;
	public ConventionCollectiveVisible = false;
	public TempsTravailVisible = false;
	public MutuelleVisible = false;
	public ModeReglementVisible = false;
	public ResponsableHierarchiqueVisible = false;
	public LibelleEmploiVisible = false;
	public DateFinPeriodeEssaiVisible = false;
	public DateFinPrevisionnelleCddVisible = false;
	public DateEntreeProfessionVisible = false;
	public ServiceVisible = false;
	public DateNaissanceVisible = false;

	public changeSize(): void {
    	this.$emit("changeSize");
	}
}



// WEBPACK FOOTER //
// ./src/components/salaries/modalFilterListeSalaries/modalFilterListeSalaries.ts